import { render, staticRenderFns } from "./finalStage.vue?vue&type=template&id=af1a3d48&scoped=true&"
import script from "./finalStage.vue?vue&type=script&lang=js&"
export * from "./finalStage.vue?vue&type=script&lang=js&"
import style0 from "./finalStage.vue?vue&type=style&index=0&id=af1a3d48&scoped=true&lang=css&"
import style1 from "./finalStage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1a3d48",
  null
  
)

export default component.exports